<template>
<div class="slide slide02">
    <h4 class="title">
        <div class="mo">홈쇼핑 앱마케팅 퍼포먼스 캠페인</div>
        Strategy &amp; Result
    </h4>
    <span class="text">
        App의 트래픽을 증대하기 위해 신규 방문부터 재방문-구매에 이르기까지 광고 프로세스 구축 <br>
        전년 대비 월 기준 약10% 이상의 트래픽 상승 달성 
    </span>
    <div class="process">
        <span>신규 방문부터 구매까지 <br class="mo">일련의 광고 프로세스 구축</span>
        <ul class="list">
            <li>신규 방문</li>
            <li>재방문</li>
            <li>구매</li>
        </ul>
    </div>
    <div class="graph">
        홈쇼핑 광고주 월간 트래픽 달성 추이
    </div> 
    <div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
    methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>